import React, { Component } from 'react'
import {
    Badge,
    Card,
    Descriptions,
    Divider,
    Table,
    Layout,
    Input,
    Row,
    Col,
    Typography,
    PageHeader,
    Select,
    List,
    Avatar,
    Tag,
    Space,
    Button,

} from 'antd';
import { CheckCircleTwoTone, HourglassTwoTone } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import { 
    getAllBreeders, 
    getAllCrops, 
    getCropsForBreeder, 
    getForecastForBreederCrop, 
    updateBreederCropForecast, 
    getAllForecastsForBreeder
} from '../util/APIUtils';

import { dynamicSort } from '../util/Helpers';

const { Title } = Typography;

export class AddCropForecast extends Component {

    constructor(props) {
        super(props);
        this.state = {
            year: null,
            breederId: props.currentUser.breederInfo.id,
            previousProjectYear: props.currentUser.previousProjectYear.projectYear,
            cropId: null,
            breeders: [],
            crops: [],
            forecasts: [],
            allForecasts: [],
            isLoading: false,
            background: null,
            activity: null,
            outlook: null,
            lastYearBackground: null,
            currentYearForecast: null
        };
    }

    fetchBreeders() {
        this.setState({ isLoading: true });
        let promise;
        promise = getAllBreeders();
        if (!promise) {
            return;
        }

        promise.then(response => {
            this.setState({
                breeders: response.sort(dynamicSort("firstName")),
                isLoading: false
            })

        }).catch(error => {
            this.setState({ isLoading: false });
        });
    }

    fetchCropsAndSummary() {
        this.setState({ isLoading: true });
        const { breederId } = this.state;

        let cropsPromise = getCropsForBreeder(breederId);
        let allForecastsPromise = getAllForecastsForBreeder(breederId); 

        Promise.all([cropsPromise, allForecastsPromise]).then(([cropsResponse, allForecastsResponse]) => {
            this.setState({
                crops: cropsResponse.sort(dynamicSort("shortName")),
                allForecasts: allForecastsResponse,
                isLoading: false
            });
        }).catch(error => {
            console.error("Error fetching data:", error);
            this.setState({ isLoading: false });
        });
    }


    updateBreederCrop = () => {

        console.log("Update breeder crop");
        this.setState({ isLoading: true });

        let breederCropForecastInfo = {
            "breederId": this.state.breederId,
            "cropId": this.state.cropId,
            "year": this.state.previousProjectYear,
            "outlook": this.state.outlook,
            "background": this.state.background,
            "activity": this.state.activity
        }

        let promise;
        promise = updateBreederCropForecast(breederCropForecastInfo);
        if (!promise) {
            return;
        }

        promise.then(response => {
            const updatedForecastsForCrop = response;
            const currentCropId = this.state.cropId;

            const otherForecasts = this.state.allForecasts.filter(f => f.cropId !== currentCropId);
            
            const newAllForecasts = [...otherForecasts, ...updatedForecastsForCrop];

            this.setState({
                forecasts: updatedForecastsForCrop.sort(dynamicSort("year")).reverse(),
                allForecasts: newAllForecasts,
                isLoading: false,
                showForm: false
            })

        }).catch(error => {
            this.setState({ isLoading: false });
        });
    }

    processForecastsForCrop(cropId) {
        const { allForecasts, previousProjectYear } = this.state;
        
        let forecastsForCropSorted = allForecasts
            .filter(f => f.cropId === cropId)
            .sort(dynamicSort("year"));
        
        let reversedForecasts = [...forecastsForCropSorted].reverse();
        
        let currentYearForecast = reversedForecasts.find(f => f.year === previousProjectYear);
        
        if (!currentYearForecast && reversedForecasts.length > 0) {
            this.setState({
                currentYearForecast: null,
                lastYearBackground: reversedForecasts[0].background,
                outlook: null,
                activity: null,
                background: null
            });
        } else if (currentYearForecast) {
            this.setState({
                currentYearForecast: currentYearForecast,
                lastYearBackground: currentYearForecast.background,
                outlook: currentYearForecast.outlook,
                activity: currentYearForecast.activity,
                background: currentYearForecast.background
            });
        } else {
             this.setState({
                currentYearForecast: null,
                lastYearBackground: null,
                outlook: null,
                activity: null,
                background: null
            });
        }
        
        this.setState({
             forecasts: reversedForecasts
        });
    }


    handleBack = e => {
        if (this.state.cropId) {
            this.setState({
                cropId: null,
                forecasts: [],
                currentYearForecast: null,
                showForm: false,
                background: null,
                activity: null,
                outlook: null,
            });
        } else {
            this
                .props
                .history
                .goBack();
        }
    };

    handleBreederSelection = (val) => {
        this.setState({
            crops: [],
            forecasts: [],
            allForecasts: [],
            breederId: val
        });

        this.fetchCropsAndSummary();
    }

    handlCropSelection = (val, showFormOnLoad = false) => {
        if (val === 0) {
             this.setState({
                cropId: null,
                forecasts: [],
                showForm: false,
                currentYearForecast: {}
            })
            return;
        }

        this.setState({
            cropId: val,
            forecasts: [],
            showForm: showFormOnLoad,
            currentYearForecast: null,
            background: null,
            activity: null,
            outlook: null,
            lastYearBackground: null
        })

        console.log(val)
        console.log(this.state.breederId)
        if (this.state.breederId && val) {
            this.processForecastsForCrop(val);
        }
    }


    componentDidMount() {
        this.fetchCropsAndSummary();
    }

    componentDidUpdate(nextProps) {
        if (this.props.isAuthenticated !== nextProps.isAuthenticated) {
            this.setState({
                breeders: [],
                crops: [],
                allForecasts: [],
                isLoading: false
            });
            this.fetchCropsAndSummary();
        }
    }

    showOutLookForm = () => {
        const { currentYearForecast, lastYearBackground } = this.state;
        this.setState({
            showForm: true,
            background: currentYearForecast?.background ?? lastYearBackground ?? null,
            activity: currentYearForecast?.activity ?? null,
            outlook: currentYearForecast?.outlook ?? null,
        });
    }

    hideForm = () => {
        this.setState({
            showForm: false,
        })
    }

    handleChange = e => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };


    render() {
        const { t } = this.props;

        console.log(this.state.allForecasts)
        console.log(this.state.previousProjectYear)

        let content;

        if (!this.state.cropId) {

            let cropsWithoutGL = [];
            let glCrop = null;
            this.state.crops.forEach(item => {
                if (item.shortName === "GL") {
                    glCrop = item;
                } else {
                    cropsWithoutGL.push(item);
                }
            });
            const sortedCrops = [...cropsWithoutGL];
            if (glCrop) {
                sortedCrops.push(glCrop);
            }

            content = (
                <Row>
                    <Col xs={24} sm={22} md={20} lg={18} xl={16}>
                        <List
                            itemLayout="horizontal"
                            dataSource={sortedCrops}
                            loading={this.state.isLoading}
                            renderItem={item => {
                                const hasCurrentYearForecast = this.state.allForecasts.some(
                                    f => f.cropId === item.id && f.year === this.state.previousProjectYear
                                );
                                
                                const icon = hasCurrentYearForecast ?
                                    <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '18px', marginTop: '4px' }} /> :
                                    <HourglassTwoTone twoToneColor="#faad14" style={{ fontSize: '18px', marginTop: '4px' }} />;
        
                                const buttonText = hasCurrentYearForecast ? "Bearbeiten" : "Jahr hinzufügen";
        
                                return (
                                    <List.Item
                                        actions={[
                                            <Button type="primary" size="small" onClick={() => this.handlCropSelection(item.id, true)}>
                                                {buttonText}
                                            </Button>
                                        ]}
                                    >
                                        <List.Item.Meta
                                            avatar={icon}
                                            title={
                                                <a onClick={() => this.handlCropSelection(item.id, false)}>
                                                    {item.shortName + " : " + item.name}
                                                </a>
                                            }
                                        />
                                    </List.Item>
                                );
                            }}
                        />
                    </Col>
                </Row>
            );

        } else {

            content = (
                <div>
                    {this.state.showForm &&
                        <Descriptions
                            size="small"
                            title={"Bericht " + this.state.previousProjectYear}
                            bordered="true">
                            <Descriptions.Item label='Hintergrund' span={3} labelStyle={{ fontWeight: 'bold' }}>
                                <Input.TextArea name="background" value={this.state.background} onChange={this.handleChange} />
                            </Descriptions.Item>
                            <Descriptions.Item label='Bericht' span={3} labelStyle={{ fontWeight: 'bold' }}>
                                <Input.TextArea name="activity" value={this.state.activity} onChange={this.handleChange} />
                            </Descriptions.Item>
                            <Descriptions.Item label='Plan' span={3} style={{ width: '200px' }} labelStyle={{ fontWeight: 'bold' }}>
                                <Input.TextArea name="outlook" value={this.state.outlook} onChange={this.handleChange} />
                            </Descriptions.Item>
                        </Descriptions>
                    }

                    {this.state.showForm && <Divider />}

                    <List
                        itemLayout="horizontal"
                        dataSource={this.state.forecasts}
                        loading={this.state.isLoading}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<Tag color="#2db7f5">{item.year}</Tag>}
                                    title={<Card title={<Title level={5}>Hintergrund </Title>} size='small'>
                                        {item.background}
                                    </Card>}
                                    description={<span>
                                        <Card title={<Title level={5}>Bericht </Title>} size='small'>
                                            {item.activity}
                                        </Card>
                                        <Card title={<Title level={5}>Plan </Title>} size='small' >
                                            {item.outlook}
                                        </Card>
                                    </span>
                                    }
                                />
                            </List.Item>
                        )}
                    />
                </div>
            );
        }


        return (
            <div>
                <PageHeader
                    className="site-page-header"
                    onBack={() => this.handleBack()} 
                    title={"ZSL Kurzberichte"}
                    subTitle={
                        this.state.cropId ?
                            this.state.crops.find(c => c.id === this.state.cropId)?.name
                            : "Kulturart auswählen"
                    }
                    extra={<Space>
                        {this.state.cropId && !this.state.showForm && (
                            <Button type='primary' onClick={this.showOutLookForm}>
                                {this.state.currentYearForecast ? "Bearbeiten" : "Jahr hinzufügen"}
                            </Button>
                        )}
                        {this.state.showForm &&
                            <><Button type='primary' onClick={this.updateBreederCrop}>Speichern</Button><Button onClick={this.hideForm}>Abbrechen</Button></>}
                    </Space>}
                />
                <Card bordered={true} headStyle={{ padding: "0" }} >
                   
                    {content}
                </Card>
            </div>
        )
    }
}

export default withTranslation()(withRouter(AddCropForecast));